import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LNGS } from '../supportedLngs.js';
import LanguageSwitcher from '../components/LanguageSwitcher';
import SiteFooter from '../components/SiteFooter';
import ObfuscatedEmail from '../components/ObfuscatedEmail';
import './LegalPage.css';

const VALID_PAGES = ['about', 'privacy', 'terms'];

function lngPrefixFromParams(lng) {
  return lng && SUPPORTED_LNGS.includes(lng) ? `/${lng}` : '';
}

export default function LegalPage({ page }) {
  const { t } = useTranslation();
  const params = useParams();
  const slug = page || params.page;
  const lng = params.lng;
  const prefix = lngPrefixFromParams(lng);

  if (!VALID_PAGES.includes(slug)) {
    return (
      <div className="legal-page">
        <LanguageSwitcher />
        <main className="legal-page__main container">
          <p>{t('legal.notFound')}</p>
          <Link to={prefix || '/'}>{t('legal.backHome')}</Link>
        </main>
        <SiteFooter />
      </div>
    );
  }

  const title = t(`legal.${slug}.title`);
  const sections = t(`legal.${slug}.sections`, { returnObjects: true });

  return (
    <div className="legal-page">
      <Helmet>
        <title>{title} — gdetotam.org</title>
        <meta name="robots" content="index, follow" />
      </Helmet>
      <LanguageSwitcher />
      <main className="legal-page__main container">
        <Link className="legal-page__back" to={prefix || '/'}>
          ← {t('legal.backHome')}
        </Link>
        <h1 className="legal-page__title">{title}</h1>
        <div className="legal-page__body">
          {Array.isArray(sections) && sections.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
          {slug === 'privacy' && (
            <p className="legal-page__contact">
              {t('legal.contactIntro')}{' '}
              <ObfuscatedEmail />
            </p>
          )}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
